export default "__VITE_ASSET__CAmWebyQ__"